export default __webpack_public_path__ + "static/media/flag-marshall-island.a7dbea3a.svg";